import { useTranslate } from 'hooks/useTranslate';
import { FC, useMemo } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const hasRequiredText = (value: string | undefined) =>
  typeof value === 'string' && value.trim().length > 0;

const PublishTradingOfferModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = usePublishTradingOfferModal();

  const isSellOffer = data.tradingOffer?.type === 'SELL';

  const buttonLabel = useMemo(() => {
    if (data.modalActionType === actionTypes.EDIT) return t('EditOffer');
    return isSellOffer
      ? t('PublishSellOfferButton')
      : t('PublishBuyOfferButton');
  }, [data.modalActionType, isSellOffer, t]);

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  const buyer = data.publisherPartner;
  const address = buyer?.address;

  const isStep2Valid =
    !!buyer &&
    hasRequiredText(buyer.name) &&
    hasRequiredText(buyer.cif) &&
    hasRequiredText(buyer.email) &&
    hasRequiredText(buyer.phone) &&
    hasRequiredText(buyer.bankAccountNumber) &&
    hasRequiredText(address?.line1) &&
    hasRequiredText(address?.zip) &&
    hasRequiredText(address?.city) &&
    hasRequiredText(address?.country) &&
    data.publisherDocuments.length > 0 &&
    data.isTermsAndConditionsAccepted;

  return (
    <>
      {!isReadOnlyView && (
        <Modal.Footer className="border-top d-flex justify-content-between">
          <div>
            {data.currentStep === 2 && (
              <Button
                variant={ButtonVariants.SECONDARY}
                outlineStyle
                icon="arrow-left"
                onClick={actions.handlePrevStep}
              >
                {t('Previous')}
              </Button>
            )}
          </div>

          <div className="d-flex">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={actions.handleCloseModal}
            >
              {t('Cancel')}
            </button>

            {data.currentStep === 1 && (
              <Button className="ml-2" onClick={actions.handleNextStep}>
                {t('Continue')}
                <em className="icon ni ni-arrow-right ml-1" />
              </Button>
            )}

            {data.currentStep === 2 && (
              <button
                type="button"
                className="btn btn-success ml-2"
                disabled={!isStep2Valid}
                onClick={actions.handlePublishTradingOffer}
              >
                <em className="icon ni ni-check mr-1" />
                <span>{buttonLabel}</span>
              </button>
            )}
          </div>
        </Modal.Footer>
      )}
    </>
  );
};

export default PublishTradingOfferModalFooter;
